<template>
    <form
        id="app"

        @click="globalClick"
        @submit.prevent
    >
        <router-view
            @sendEvent="receiveEvent"
        ></router-view>
    </form>
</template>

<script>
    import { mapMutations } from 'vuex'
    import VueCookie from 'vue-cookie'

    export default {
        data: function(){
            let _screenWidth = document.body.clientWidth;

            return {
                screenWidth: _screenWidth //監控 resize 事件
            }
        },
        watch: {
            screenWidth: {
                handler: function(){
                    this.globalResizeFuncQueueRun();
                }
            },
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueueRun',
                'globalResizeFuncQueueRun',
                'globalScrollFuncQueueRun',
                'clearToolTip',
                'sendError'
            ]),
            receiveEvent: function(func, arg){ //將收到的方法，推送給其他方法執行

                if( this[func] ) {
                    this[func](arg);
                }else {
                    console.log(func +' 方法遺失了。');
                }
            },
            globalClick: function(){
                this.globalClickFuncQueueRun();
                this.clearToolTip();
            },
            getSiteMode: function(){
                let _isDevEvent = this.$siteConfig.devEvent;

                if( _isDevEvent ){
                    let $title = document.querySelector('title'),
                        _title = $title.innerText;

                    $title.innerText = '*'+ _title;
                }
            },
        },
        created: function(){
            let _colorSetLog = VueCookie.get('colorSetLog');

            if( _colorSetLog ) {
                document.querySelector('html').setAttribute('style', _colorSetLog);

                VueCookie.set('colorSetLog', _colorSetLog, 365);
            }

            let $that = this; //監看變化

            window.onresize = () => {
                $that.screenWidth = document.body.clientWidth;
            }

            document.body.onscroll = () => {
                $that.globalScrollFuncQueueRun();
            }

            this.getSiteMode();
        }
    }
</script>

<style lang="scss">

</style>
